import React, { useState, useEffect } from "react";
import axios from "axios";

const StudentAchievement = () => {
  // ✅ Must match the session used by admin
  const sessionId = localStorage.getItem("currentSessionId");

  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ================= FETCH ACHIEVEMENTS =================
  useEffect(() => {
    const fetchAchievements = async () => {
      if (!sessionId) {
        setError("Session ID not found");
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/studentAchievements/getAchievementsBySession/${sessionId}`
        );
        setAchievements(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching achievements:", err);
        setError("Failed to fetch achievements");
        setLoading(false);
      }
    };

    fetchAchievements();
  }, [sessionId]);

  if (loading)
    return <div className="text-center py-6 text-lg">Loading achievements...</div>;

  if (error)
    return <div className="text-center py-6 text-red-500 text-lg">{error}</div>;

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8">
      <h1 className="text-xl font-bold mb-6 text-center text-gray-800">
        🎓 Student Achievements
      </h1>

      {achievements.length === 0 ? (
        <div className="text-center text-lg text-gray-600">
          No achievements found for this session.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {achievements.map((a) => (
            <div
              key={a._id}
              className="bg-white shadow-md rounded-lg p-4 hover:shadow-lg transition-shadow duration-300"
            >
              <h2 className="text-lg font-semibold mb-2">{a.competitionTitle}</h2>
              <p className="text-gray-600 text-sm mb-1">
                📅 {new Date(a.date).toLocaleDateString()}
              </p>
              <p className="text-gray-700 text-sm mb-1">🏆 Place: {a.place}</p>
              <p className="text-gray-700 text-sm mb-2">🎖 Rank: {a.schoolRank}</p>
              <p className="text-gray-800 text-sm mb-3">{a.description}</p>

              {a.image && (
                <img
                  src={a.image}
                  alt={a.competitionTitle}
                  className="w-full h-40 object-cover rounded mb-2"
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentAchievement;
